import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { LocaleService } from './services/locale.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet
  ],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit{
  localeService = inject(LocaleService);
  localStorage: Storage = localStorage
  title = 'Tokenización de tarjetas';

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const country = params['country'];
      if (country) {
        this.localeService.setFooter(country);
      }
    });
  }
}
